import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import {StudyType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {CreateStudyModalOptionalParams} from 'studies/sidepanel/NewStudyDropdown';

import {ClinicalStudyState, StudySchema, TypedStudyAdapter} from '../utils/TypedStudyTypes';
import ClinicalStudyDesignTabContents from './ClinicalStudyDesignTabContents';
import ClinicalStudyExecutionOverview from './ClinicalStudyExecutionOverview';
import ClinicalStudyOverviewTabContents from './ClinicalStudyOverviewTabContents';

export const ClinicalStudyAdapter: TypedStudyAdapter<never, never, ClinicalStudyState> = {
  type: StudyType.CLINICAL,

  isMultiProcedureRunEnabled: true,

  isMultiBatchEnabled: false,

  isMultiConditionEnabled: false,

  isNotificationSchedulesEnabled: false,

  isUnitOperationInstanceLinkingEnabled: false,

  isVisualizationEnabled: false,

  allowReturnToDesignPhase: true,

  allowRequireDesignApproval: BenchlingConfig.STUDIES_ENABLE_REVIEW,

  modalOptions: (stepKey: never) => ({}),

  getButtonsByStep() {
    return null;
  },

  renderMetadataSection(state: ClinicalStudyState) {
    return <></>;
  },

  getSteps: () => [],

  renderStep(key: never) {},

  useTypedStudyState(this: void, studySchema: StudySchema, initialValues: CreateStudyModalOptionalParams) {
    return {experimentParam: null};
  },

  getPerformanceMetadata(state: ClinicalStudyState) {
    return {};
  },

  getAnalyticsMetadata(state: ClinicalStudyState) {
    return {};
  },
  creation: {
    async: false,
  },
  design: {
    ui: {
      tab: ClinicalStudyDesignTabContents,
    },
  },
  overview: {
    ui: {
      tab: ClinicalStudyOverviewTabContents,
      execution: ClinicalStudyExecutionOverview,
      design: null,
    },
  },
  review: {
    analysis: {
      disallowAdhocAnalysis: true,
    },
  },
};
